import { selectRussianPluralForm } from '../../utils/formatters'

export const NOTIFICATIONS_TEXT = {
  title: 'Уведомления',
  markAllRead: 'Прочитать все',
  close: 'Закрыть уведомления',
  showMore: 'Показать ещё',
  retry: 'Повторить',
  loading: 'Загрузка уведомлений',
  emptyAll: 'Уведомлений пока нет',
  emptyFiltered: 'Нет уведомлений этого типа',
  filtersLabel: 'Фильтр уведомлений',
  unreadMarker: 'Непрочитанное',
  toastsRegion: 'Новые уведомления',
  toastOpen: 'Открыть',
  toastMarkRead: 'Прочитано',
  toastClose: 'Закрыть уведомление'
} as const

export type NotificationsFilter = 'all' | 'unread' | 'comments' | 'payments' | 'statuses'

export const NOTIFICATIONS_FILTER_LABELS: Record<NotificationsFilter, string> = {
  all: 'Все',
  unread: 'Непрочитанные',
  comments: 'Комментарии',
  payments: 'Оплата и приёмка',
  statuses: 'Статусы'
}

/** «Уведомления», «Уведомления, 1 непрочитанное», «Уведомления, 3 непрочитанных». */
export function formatNotificationsLabel(unreadCount: number): string {
  if (unreadCount <= 0) {
    return NOTIFICATIONS_TEXT.title
  }
  const noun = selectRussianPluralForm(unreadCount, ['непрочитанное', 'непрочитанных', 'непрочитанных'])
  return `${NOTIFICATIONS_TEXT.title}, ${unreadCount} ${noun}`
}
